import { useState, useEffect } from "react";
import styled from "styled-components";
import { searchAuthors } from "../../services/AuthorService";
import { Container, Input, Dropdown, DropdownItem } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";

const SelectedList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px; 
`;


const SelectedAuthor = styled.div`
  background: ${({ theme }) => theme.colors.lineColor}33;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export default function AuthorSelector({ selectedAuthors, setSelectedAuthors, setShowAuthorModal }) {
    const [query, setQuery] = useState("");
    const [authors, setAuthors] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (query.length < 2) {
            setAuthors([]);
            return;
        }

        const handler = setTimeout(async () => {
            setLoading(true);
            try {
                const results = await searchAuthors(query);
                setAuthors(results);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }, 300);

        return () => clearTimeout(handler);
    }, [query]);

    const handleSelect = (author) => {
        if (!selectedAuthors.find((a) => a.id === author.id)) {
            setSelectedAuthors((prev) => [...prev, author]);
        }
        setQuery("");
        setAuthors([]);
    };

    const handleRemove = (id) => {
        setSelectedAuthors((prev) => prev.filter((a) => a.id !== id));
    };
    return (
        <Container style={{ position: "relative", marginBottom: "3rem" }}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
                alignItems: "center",
                marginBottom: "1rem"
            }}>
                <div style={{ display: "flex", gap: "8px" }}>
                    <Input
                        value={query}
                        placeholder="Pretraži autora..."
                        onChange={(e) => setQuery(e.target.value)}
                        style={{ marginBottom: "0px" }}
                    />
                    <Button
                        tekst={"+"}
                        akcija={() => {
                            setShowAuthorModal(true);
                        }}
                    />
                </div>
            </div>
            {authors.length > 0 && (
                <Dropdown>
                    {authors.map((author) => (
                        <DropdownItem key={author.id} onClick={() => handleSelect(author)}>
                            {author.name} {author.surname}
                        </DropdownItem>
                    ))}
                </Dropdown>
            )}
            <h4>Odabrani autori:</h4>
            <SelectedList>
                {selectedAuthors.map((author) => (
                    <SelectedAuthor key={author.id}>
                        {author.name} {author.surname}
                        <button onClick={() => handleRemove(author.id)}>✖</button>
                    </SelectedAuthor>
                ))}
            </SelectedList>
        </Container>
    );
}
